import { useQuery, keepPreviousData } from '@tanstack/react-query';
import {
  ListSuperadminAiUsageRequest,
  ListSuperadminAiUsageResponse,
  listSuperadminAiUsageContract
} from '@bliks-io/contracts';
import { apiClient } from '@/api/client';
import { aiUsageKeys } from '@/api/query-keys';

export type AiUsageFilters = ListSuperadminAiUsageRequest;

export function useSuperAdminAiUsage(filters: AiUsageFilters = {}) {
  return useQuery({
    queryKey: aiUsageKeys.list(filters),
    queryFn: async ({ signal }): Promise<ListSuperadminAiUsageResponse> => {
      const { data } = await apiClient.get<ListSuperadminAiUsageResponse>(
        listSuperadminAiUsageContract.path,
        { params: filters, signal }
      );
      return data;
    },
    placeholderData: keepPreviousData
  });
}
